export const isSinchActionMenuOption = el => {
  return el instanceof Element && el.tagName === 'SINCH-ACTION-MENU-OPTION';
};